import { useId, useState } from "react";
import { Card, CardBody, CardText, Collapse } from "reactstrap";

import "../styles/CommitteeCard.css";

export default function CommitteeCard({ title, text, members = [] }) {
  const [isOpen, setIsOpen] = useState(false);
  const contentId = useId();

  return (
    <Card className="committee-card">
      <CardBody>
        <h3 className="committee-card-heading">
          <button
            type="button"
            className="committee-card-toggle"
            aria-expanded={isOpen}
            aria-controls={contentId}
            onClick={() => setIsOpen((previous) => !previous)}
          >
            <span>{title}</span>
            <i
              className={`bi bi-${isOpen ? "dash" : "plus"}-circle-fill committee-card-icon`}
              aria-hidden="true"
            />
          </button>
        </h3>
        {text && <CardText className="committee-card-text">{text}</CardText>}
        <Collapse isOpen={isOpen} id={contentId}>
          <ul className="committee-card-members">
            {members.map((member) => (
              <li key={member.name}>{member.name}</li>
            ))}
          </ul>
        </Collapse>
      </CardBody>
    </Card>
  );
}
